
const initialState = {
    getTotal: {},
    getMale: {},
    getTransgender: {},
    getFemale: {},
    total:[],
    getState: 0,
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case "TOTAL_POPULATION_FULFILLED":
        return {
          ...state,
          getState: 2,
          getTotal: action.payload.data,
        };
      case "TOTAL_POPULATION_REJECTED":
        return { ...state, getState: 3 };
      case "TOTAL_POPULATION_PENDING":
        return { ...state, getState: 1 };
      case "TOTAL_MALE_POPULATION_FULFILLED":
        return {
          ...state,
          getState: 2,
          getMale: action.payload.data,
        };
      case "TOTAL_MALE_POPULATION_REJECTED":
        return { ...state, getState: 3 };
      case "TOTAL_MALE_POPULATION_PENDING":
        return { ...state, getState: 1 };
      case "TOTAL_FEMAIL_POPULATION_FULFILLED":
        return {
          ...state,
          getState: 2,
          getFemale: action.payload.data,
        };
      case "TOTAL_FEMAIL_POPULATION_REJECTED":
        return { ...state, getState: 3 };
      case "TOTAL_FEMAIL_POPULATION_PENDING":
        return { ...state, getState: 1 };
      case "TOTAL_TRANSGENDER_POPULATION_FULFILLED":
        return {
          ...state,
          getState: 2,
          getTransgender: action.payload.data,
        };
      case "TOTAL_TRANSGENDER_POPULATION_REJECTED":
        return { ...state, getState: 3 };
      case "TOTAL_TRANSGENDER_POPULATION_PENDING":
        return { ...state, getState: 1 };
      case "TOTAL_COUNT_FULFILLED":
        return {
          ...state,
          getState: 2,
          total: action.payload.data,
        };
      case "TOTAL_COUNT_REJECTED":
        return { ...state, getState: 3 };
      case "TOTAL_COUNT_PENDING":
        return { ...state, getState: 1 };
  
      default:
        return state;
    }
  };
  
  export default reducer;
  